export const transformDigitalLabelType = _ref => {
  let {
    icon_url,
    subtitle,
    title,
    type
  } = _ref;
  return {
    iconUrl: icon_url,
    subtitle,
    title,
    type
  };
};
export const transformDigitalLabelTypes = data => data.map(transformDigitalLabelType);